import { cn } from '@/lib/utils';

interface LogoProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  showText?: boolean;
}

const Logo = ({ className, size = 'md', showText = true }: LogoProps) => {
  const sizes = {
    sm: { icon: 'h-6 w-6', text: 'text-lg' },
    md: { icon: 'h-8 w-8', text: 'text-xl' },
    lg: { icon: 'h-12 w-12', text: 'text-2xl' },
  };

  return (
    <div className={cn('flex items-center gap-2 group', className)}>
      <svg
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={cn(sizes[size].icon, 'transition-transform duration-200 group-hover:scale-105')}
      >
        {/* Background rounded square */}
        <rect
          x="2"
          y="2"
          width="28"
          height="28"
          rx="6"
          className="fill-primary transition-all duration-200"
        />
        
        {/* Checklist lines */}
        <rect
          x="8"
          y="9"
          width="12"
          height="2"
          rx="1"
          className="fill-primary-foreground"
        />
        <rect
          x="8"
          y="15"
          width="16"
          height="2"
          rx="1"
          className="fill-primary-foreground"
        />
        <rect
          x="8"
          y="21"
          width="10"
          height="2"
          rx="1"
          className="fill-primary-foreground"
        />
        
        {/* Checkmark with bounce animation on load and scale on hover */}
        <path
          d="M22 10L24.5 12.5L28 7"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="stroke-primary-foreground fill-none transition-transform duration-300 origin-center group-hover:scale-110 animate-checkmark-bounce"
        />
      </svg>
      
      {showText && (
        <span className={cn('font-display font-bold text-foreground', sizes[size].text)}>
          Nexihow
        </span>
      )}
    </div>
  );
};

export default Logo;
